/**
 * @generated SignedSource<<a7dc4dc57d05ecf0da8d3d01949f1392>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorePackageSuccess_package$data = {
  readonly __typename: string;
  readonly " $fragmentType": "StorePackageSuccess_package";
};
export type StorePackageSuccess_package$key = {
  readonly " $data"?: StorePackageSuccess_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorePackageSuccess_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorePackageSuccess_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "Package",
  "abstractKey": "__isPackage"
};

(node as any).hash = "deddd049617ccfff04b05bc4fd69d742";

export default node;
